import Icon from '../components/Icon.vue'

Icon.register({
  church: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M464.5 246.7c9.6 5.8 15.5 16.2 15.5 27.4v237.9h-96v-96c0-35.3-28.7-64-64-64s-64 28.7-64 64v96h-96v-237.9c0-10 7-22.3 15.5-27.4l112.5-67.5v-51.2h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48v51.2zM0 396c0-11.6 8.7-24.8 19.4-29.4l108.6-46.5v192h-112c-8.8 0-16-7.2-16-16v-100zM620.6 366.5c11.8 5 19.4 16.6 19.4 29.4v100c0 8.8-7.2 16-16 16h-112v-192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/church.js
// module id = 1197
// module chunks = 0